import { configureStore } from '@reduxjs/toolkit';
import { authService } from './services/authServices';
import authReducer from './reducers/authReducer';
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { userService } from './services/userServices';
import { tutorService } from './services/tutorServices';
import courseService from './services/courseServices';
import blogService from './services/blogServices';

const authPersistConfig = {
    key: 'auth',
    storage: storage,
};

export const store = configureStore({
    reducer: {
        auth: persistReducer(authPersistConfig, authReducer),
        [authService.reducerPath]: authService.reducer,
        [userService.reducerPath]: userService.reducer,
        [tutorService.reducerPath]: tutorService.reducer,
        [courseService.reducerPath]: courseService.reducer,
        [blogService.reducerPath]: blogService.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }).concat([authService.middleware, userService.middleware, tutorService.middleware, courseService.middleware, blogService.middleware]),
});

export let persistor = persistStore(store);